import { Suspense } from 'react';
import './MainLayout.scss';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { notification } from 'antd';
import Chat from '../../chat/Chat';
import { useDeviceType } from '../../../hooks/useDeviceType';
import PageAlertMobile from '../../../pages/PageAlertMobile/PageAlertMobile';
import { cn } from '../../../utils/string/cn.utils';
import useScrollToTop from '../../../hooks/useScrollToTop';
import useScrollHeader from '../../../hooks/useScrollHeader';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const MainLayout = () => {
  notification.destroy();
  const device = useDeviceType();
  useScrollToTop();
  useDocumentTitle();

  useScrollHeader(device);

  // Detect button visibility

  return (
    <Layout
      className={cn(
        'h-[100vh] bg-[#F7F7F7]',
        device !== 'desktop' ? '#fff' : ''
      )}
    >
      <Content
        id="scrollableDiv"
        className={cn(
          'transition-all duration-300 ease-linear overflow-auto lg:mt-[150px] mt-[57px]'
        )}
      >
        {/* {device === 'desktop' ? (
          <>
            <Header />
            <Suspense>
              <Outlet />
            </Suspense>
            <Footer />
            <Chat />
          </>
        ) : (
          <PageAlertMobile />
        )} */}
        <>
          <Header />
          <Suspense>
            <Outlet />
          </Suspense>
          <Footer />
          <Chat />
        </>
      </Content>
    </Layout>
  );
};

export default MainLayout;
